module.exports = __webpack_public_path__ + "media/application/images/ui/kiwi-icon-reversed-8fdf9ede66f78d60b3a10e3b1e8c7c91.png";